import * as React from 'react'

import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'
import upperCase from 'lodash/upperCase'

import i18n from 'modules/core/lib/i18n'

import * as stylesRefs from '../index.vanilla.css'

const CoverageTitle = () => {
  const cx = useClassNames(stylesRefs)
  const title = i18n.t('shift_management.coverage_section.title')

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      width="full"
      height="full"
      paddingX="s8"
      className={cx('header', 'sticky')}
    >
      <Box flexDirection="row" alignItems="center" width="s240" gap="s8" height="full">
        <Text size="100" weight="bold" color="grey700">
          {upperCase(title)}
        </Text>
      </Box>
    </Box>
  )
}

export default CoverageTitle
